<div class="content-block">

  <!-- Content Header (Page header) -->

  <div class="content-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">
          <h1 class="m-0 text-dark">Allegati Generici </h1>
        </div><!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="/home">Dashboard</a></li>
            <li class="breadcrumb-item">Allegati Generici</li>
          </ol>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div>
</div>

<div class="content-block">


  <section class="col-lg-12 ">

    <div class="card primary">
      <div class="card-header">
        <h3 class="card-title">
          <i class="fa fa-chart-pie mr-1"></i>
          Allegati Generici
        </h3>

      </div><!-- /.card-header -->
      <div class="card-body">

        <div class="row">
          <div class="col-xl-4 col-lg-6 col-sm-12 col-xs-12 mb-6">
            <div class="dx-field">
              <div class="dx-field-label">Cartella</div>
              <div class="dx-field-value">
                <dx-lookup [dataSource]="listGruppi" [searchEnabled]="true" [(value)]="gruppoFilter"
                  (onValueChanged)="onGruppoSelected()">
                </dx-lookup>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-sm-12 col-xs-12 mb-6">
            @if(!attaching){
            <dx-button stylingMode="contained" text="Allega" icon="plus" type="normal" (onClick)="onNuovoAllegato()"
              style="width: 150px; margin: 10px;">
            </dx-button>
            }
            @if(attaching){
            <form>
              <div class="row">
                <div class="col-12">
                  <div class="dx-fieldset-header">Nome allegato</div>
                  <dx-text-box [(value)]="nomeAllegato">
                    <dx-validator>
                      <dxi-validation-rule type="required" message="Inserire il nome"></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </div>
                <div class="col-12">
                  <div class="dx-fieldset-header">Cartella</div>
                  <dx-text-box [(value)]="gruppoNuovoAllegato">
                    <dx-validator>
                      <dxi-validation-rule type="required" message="Inserire la cartella"></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="widget-container">
                    <div class="dx-fieldset-header">File </div>
                    <dx-file-uploader #fileUploader [multiple]="false" accept="*" [(value)]="value"
                      uploadMode="useForm">
                      <dx-validator>
                        <dxi-validation-rule type="required" message="Selezionare il file"></dxi-validation-rule>
                      </dx-validator>
                    </dx-file-uploader>
                    <div class="content">
                      @if(value.length > 0){
                      <h4>Selected Files</h4>
                      }
                      @for (file of value; track file) {
                      <div>
                        <div class="selected-item">
                          Name:
                          <span>{{file.name}}</span><br /> Size:
                          <span>{{file.size}}</span>bytes<br /> Type:
                          <span>{{file.type}}</span><br /> Last Modified Date:
                          <span>{{file.lastModifiedDate}}</span>
                        </div>
                      </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <dx-button stylingMode="contained" text="Allega" width="120" type="success"
                    (onClick)="allegaFile($event, fileUploader.value)">
                  </dx-button>
                  <dx-button stylingMode="contained" text="Annulla" width="120" type="error"
                    (onClick)="onAnnullaAllegato()">
                  </dx-button>
                </div>
              </div>
            </form>
            }

          </div>
        </div>
        @if(dsAllegati){
        <div class="row">
          <div class="col-12">

            <dx-data-grid [dataSource]="dsAllegati" [showBorders]="true" [columnAutoWidth]="true"
              (onExporting)="onExporting($event)">

              <dxo-export [enabled]="true"></dxo-export>
              <dxo-editing mode="row" [allowAdding]="false" [allowUpdating]="true" [allowDeleting]="true"
                [useIcons]="true">
                <dxo-texts confirmDeleteMessage="Vuoi eliminare l'allegato?"></dxo-texts>
              </dxo-editing>
              <dxi-column dataField="id" [visible]="false"></dxi-column>

              <dxi-column name="scaricaFile" [allowFiltering]="false" [allowSorting]="false" cellTemplate="scaricaFile"
                caption="" width="25" [allowEditing]="false">
              </dxi-column>
              <dxi-column name="vediFile" [allowFiltering]="false" [allowSorting]="false" cellTemplate="vediFile"
                caption="" width="25">
              </dxi-column>
              <dxi-column dataField="dataRif" type="date" format="dd/MM/yyyy" [allowEditing]="false"></dxi-column>
              <dxi-column dataField="nome" [allowEditing]="false"></dxi-column>
              <div *dxTemplate="let d of 'scaricaFile'">
                <i class="dx-icon-download" (click)="scaricaFile(d.data)" style="cursor: pointer;" data-toggle="tooltip"
                  data-placement="top" title="Scarica allegato"></i>
              </div>
              <div *dxTemplate="let d of 'vediFile'">
                @if(endsWith(d.data.nomeFile, '.jpg') || endsWith(d.data.nomeFile, '.png')){
                <i class="dx-icon-image" (click)="visualizzaImmagine(d.data)" style="cursor: pointer;"
                  data-toggle="tooltip" data-placement="top" title="Visualizza immagine"></i>
                }
                @if(endsWith(d.data.nomeFile, '.pdf')){
                <i class="dx-icon-doc" (click)="visualizzaFile(d.data)" style="cursor: pointer;" data-toggle="tooltip"
                  data-placement="top" title="Visualizza allegato"></i>
                }
              </div>

              <dxi-column dataField="idReparto" caption="Visibilità" cellTemplate="viewCellTemplate"
                editCellTemplate="editCellTemplate" alignment="left"></dxi-column>

              <div *dxTemplate="let d of 'viewCellTemplate'">
                @if(d.data.idReparto == undefined || d.data.idReparto == null){
                Tutti i reparti
                }
                @else{
                {{getReparto(d.data.idReparto)}}
                }
              </div>

              <div *dxTemplate="let d of 'editCellTemplate'">
                <dx-lookup [dataSource]="listReparti" valueExpr="id" [displayExpr]="displayReparto"
                  [searchEnabled]="true" [(value)]="d.data.idReparto"
                  (onValueChanged)="d.setValue($event.value)">
                </dx-lookup>
              </div>

            </dx-data-grid>


          </div>
        </div>
        }


      </div><!-- /.card-body -->
    </div>
    <!-- /.card -->

  </section>



</div>

<dx-popup [width]="600" [height]="450" [showTitle]="true" title="" [dragEnabled]="false" [hideOnOutsideClick]="true"
  [(visible)]="popupImageVisible">
  <img style="max-width: 100%; max-height: 100%;" [src]="currentImage" alt="Immagine Allegato"></dx-popup>

  <dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="visibleLoadPanel" [showIndicator]="true"
  [showPane]="true" [shading]="true" [hideOnOutsideClick]="false">
</dx-load-panel>